import { apiCall } from './generated/gqlClient';

const getAllMembershipsApiRequest = async () => {
  const query = `
    query getMemberships {
      getMemberships {
        id
        providerId
        svcGroupId
        name
        description
        price
        sessionsCounter
        duration
        durationType
        isRecurringPayment
        isPublished
        startTime
        endTime
        userHasMembership
        group {
          id
          name
          providerId
          color
        }
      }
    }
  `;
  return apiCall({ query });
};

const getMyMembershipsApiRequest = async () => {
  const query = `
    query getMyMemberships {
      getMyMemberships {
        id
        userId
        sessionsCounter
        startTime
        endTime
        membership {
          sessionsCounter
          name
          description
          price
          duration
          durationType
          group {
            id
            name
            color
          }
        }
      }
    }
  `;
  return apiCall({ query });
};

const getProviderMembershipsApiRequest = async membershipId => {
  const query = `
    query getProviderMemberships($membershipId: Int) {
      getProviderMemberships(membershipId: $membershipId) {
        id
        userId
        membershipId
        sessionsCounter
        reservationsCounter
        isActive
        startTime
        endTime
        totalSessionsCounter
        totalReservationsCounter
        membershipType
        allInclusive
        membershipTypeIds
        describedName
        customerId
        rules
        isRequested
        userBundleId
        bundleName
        user {
          id
          name
          email
        }
        membership {
          name
          id
          sessionsCounter
          reservationsCounter
          membershipType
          membershipTypeIds
          allInclusive
          price
          startTime
          endTime
          description
          isPublished
          duration
          durationType
          group {
            id
            name
            color
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { membershipId } });
};

const getMembershipsWithRulesApiRequest = async () => {
  const query = `
    query getMembershipsWithRules {
      getMembershipsWithRules {
        id
        name
        description
        providerId
        startTime
        endTime
        price
        sessionsCounter
        alwaysAvailable
        duration
        durationType
        isPublished
        membershipType
        domain
        allInclusive
        membershipTypeIds
        reservationsCounter
        isPrimary
        rules
        membershipRules {
          id
          name
          amount
          period
          type
        }
        group {
          id
          name
          color
        }
      }
    }
  `;
  return apiCall({ query });
};

// Create / Update
const saveMembershipApiRequest = async (name, description, price, sessionsCounter, svcGroupId, startTime, endTime, isPublished, id) => {
  const mutation = `
    mutation saveMembership(
      $name: String!
      $description: String!
      $price: Float!
      $sessionsCounter: Int!
      $svcGroupId: Int!
      $startTime: DateTime
      $endTime: DateTime
      $isPublished: Boolean
      $id: Int
    ) {
      saveMembership(
        name: $name
        description: $description
        price: $price
        sessionsCounter: $sessionsCounter
        svcGroupId: $svcGroupId
        startTime: $startTime
        endTime: $endTime
        isPublished: $isPublished
        id: $id
      ) {
        success
        message
        id
      }
    }
  `;
  return apiCall({
    query: mutation,
    variables: { name, description, price, sessionsCounter, svcGroupId, startTime, endTime, isPublished, id },
  });
};

const toggleMembershipStatusApiRequest = async (id, isPublished) => {
  const mutation = `
    mutation toggleMembershipStatus($id: Int!, $isPublished: Boolean!) {
      toggleMembershipStatus(id: $id, isPublished: $isPublished) {
        success
        message
        id
      }
    }
  `;
  return apiCall({ query: mutation, variables: { id, isPublished } });
};

export {
  getAllMembershipsApiRequest,
  getMembershipsWithRulesApiRequest,
  getMyMembershipsApiRequest,
  getProviderMembershipsApiRequest,
  saveMembershipApiRequest,
  toggleMembershipStatusApiRequest,
};
